// extracted by mini-css-extract-plugin
export var checkService = "style-mod--check-service--94304";
export var extraService = "style-mod--extra-service--ce4e7";
export var regularCheckbox = "style-mod--regular-checkbox--5f180";
export var serviceContainer = "style-mod--service-container--c4e35";
export var servicePrice = "style-mod--service-price--0a9b1";
export var servicePriceAtCompare = "style-mod--service-price-at-compare--1e086";
export var servicePrices = "style-mod--service-prices--7bd67";
export var serviceTitle = "style-mod--service-title--ea1a3";